import Pararax from './pararax';
import ScrollAnimation from './scrollanimation';

let pararax;
let scrollAnimation;

export default class smoothScrollManager{
    constructor(param,effect,pageID){

        pararax = new Pararax();
        scrollAnimation = new ScrollAnimation(effect,pageID);

        this.w = window.innerWidth;
        this.h = window.innerHeight;

        this.$root = document.getElementById("l-root");
        this.$rootLoad = document.getElementById("l-root-load");
        this.$pararax = document.getElementsByClassName("js__psc");

        this.$prarax;
        this.$target;

        this.inc = 0;
        this.nowInc = 0;
        this.prevInc = 0;

        this.inertia = (Useragnt.mobile||Useragnt.tablet||param.browserType === 'IE'||param.browserType === 'safari')?false:true; /* 慣性スクロールを有効にするか */

        this.bodyMatrix;
        this.pararaxMatrix;

        /* 状態監視用のフラグ */
        this.status = {
            controll : false, /* ページャーなどで操作しているか */
            comp     : true, /* 慣性スクロールが完了したか */
            start    : false,
            rendering: true,
        }

        this.param = param;
        this.effect = effect;
        this.pageID = pageID;

        if(this.pageID !== 'top') return;
        this.policy = document.getElementById('p-top-policy__list');
        this.policyHeight = this.policy.offsetHeight;
        this.policyOffset = this.policy.getBoundingClientRect().top;
        this.screenHeight = window.outerHeight;
        this.cover = document.getElementById('p-kv-cover');

    }
    init(){

        let _this = this;

        if(!this.inertia){
            TweenMax.set(document.body, {className:"+=is-inertia-none"});
        }

        let _footerpagetop = document.getElementById('l-footer-pagetop');
        _footerpagetop.onclick = () => {
            // TweenLite.to('body,html', .5, {
            //     scrollTo:{y:0}
            // });
            this.inc = 0;
            this.nowInc = 0;
            this.prevInc = 0;
            TweenMax.to(window, .5, {
                scrollTo : { y: 0, autoKill:false },
                ease: Power2.easeOut,
                overwrite: 10
            });
        };

    }
    update(inc,dir){ /* スクロール方向を決めうちしないならdirは空で渡してください */
        this.inc = inc;
        this.dir = (dir==="")?(this.inc>this.prevInc)?"next":"prev":dir;
        this.status.comp = false;
    }

    move(fpsRate) {

        if(!this.status.start) return;

        let add = (this.inertia) ?0.1:0.18;

        this.nowInc += add * (this.inc - this.nowInc)*fpsRate;
        this.nowInc = (this.nowInc>=0)?Math.round(this.nowInc*100 )/100:0;

        this.trans();

    }
    trans() {

        if(this.inertia){
            this.$root.style.transform = 'translate3d(' + 0 + ',-' + this.nowInc + 'px ,' + 0 + ')';
        }
        /* スクロール連動で動作 */
        pararax.check(this.nowInc,this.h,this.param);

        /* アニメーション対象の要素があるかチェック */
        scrollAnimation.check(this.nowInc,this.h);

        // if(this.pageID === 'top'){
        //     this.effect.svgMorph('pause');
        // }

        if(this.nowInc>this.prevInc&&this.nowInc-this.prevInc < 0.1||
            this.nowInc<this.prevInc&&this.prevInc-this.nowInc < 0.1){
            this.onComplete();
        }
        this.prevInc = this.nowInc;

        if(this.pageID === 'top') {
            if (this.nowInc > 5) {
                if (!this.status.rendering) return;
                this.status.rendering = false;
                window.mv_main.stopRender();
                if(!this.inertia){
                    TweenMax.set(this.cover, {
                        display: 'block',
                    });
                }
            } else {
                if (this.status.rendering) return;
                this.status.rendering = true;
                window.mv_main.resumeRender();
                if(!this.inertia){
                    TweenMax.set(this.cover, {
                        display: 'none',
                    });
                }
            }
        }

    }

    resize (_w,_h) {

        this.w = _w;
        this.h = _h;
        if(this.$root.classList.contains('is-modal-open')) return;

        if(this.param.screenType === 'full'){
            document.body.style.height = this.h + 'px';
        }else{
            document.body.style.height = this.$rootLoad.clientHeight + 'px';
        }

        pararax.resize(_h);
        pararax.check(this.nowInc,this.h,this.param);
        scrollAnimation.resize(_h);

    }

    /* -------------------------------------------

      -- Callback

    ------------------------------------------- */

    onComplete(){ /* スクロール動作が終わったら */
        if(this.status.comp) return;
        this.status.comp = true;

        if(this.param.userAgent === 'sp' || this.param.userAgent === 'tablet' || this.param.browserType === 'IE' || this.param.browserType === 'safari') return;

        //body用
        this.bodyMatrix = this.$root.style.transform;
        this.bodyMatrix = this.translate(this.bodyMatrix);
        this.$root.style.transform = 'translate3d(' + 0 + ',' + this.bodyMatrix + 'px ,' + 0 + ')';

        // if(this.pageID !== 'top') return;
        // this.policyHeight = this.policy.offsetHeight;
        // this.policyOffset = this.policy.getBoundingClientRect().top;
        // this.screenHeight = window.outerHeight;
        // this.policyPosition = this.policyOffset - this.screenHeight;
        //
        // if (-this.screenHeight <= (this.policyPosition + this.policyHeight) && this.policyPosition < 0) { //see
        //     this.effect.svgMorph('play');
        // }

    }

    translate(translate){
        let re = /translate3d\((.*)\)/;
        let vals = translate.match(re)[1].replace(/ /g, "").split(",");
        return parseInt(vals[1]);
    }

    matrix2d(matrix3d){
        let re = /matrix\((.*)\)/;
        if(matrix3d === 'none') return;
        let vals = matrix3d.match(re)[1].replace(/ /g, "").split(",");
        vals = vals.map(Number)
        let matrix = [new Array(4),new Array(4),new Array(4),new Array(4)];

        matrix[0][0] = vals[0];
        matrix[0][1] = vals[1];
        matrix[0][2] = 0;
        matrix[0][3] = 0;
        matrix[1][0] = vals[2];
        matrix[1][1] = vals[3];
        matrix[1][2] = 0;
        matrix[1][3] = 0;
        matrix[2][0] = 0;
        matrix[2][1] = 0;
        matrix[2][2] = 1;
        matrix[2][3] = 0;
        matrix[3][0] = vals[4];
        matrix[3][1] = vals[5];
        matrix[3][2] = 0;
        matrix[3][3] = 1;

        return matrix;
    }

}